


































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import inViewport from 'vue-in-viewport-mixin';

@Component({
    mixins: [inViewport],
    watch: {
        'inViewport.now'(visible) {
            if (visible) {
                [this.$refs.number1, this.$refs.number2, this.$refs.number3].forEach(
                    (v: any) => v.restart()
                );
            }
        }
    }
})
export default class Story extends Vue {
    private format(value: number) {
        return value.toLocaleString(
            undefined,
            {maximumFractionDigits: 0}
        );
    }
}
